import { makeGetRequest, makePostRequest } from '../helpers/api'
import { configWithAuth, configWithoutAuth } from '../helpers'

export const studentService = {
    getUserInfo: (appVersion) => makeGetRequest('user/v2?appVersion=Capeesh:' + appVersion, configWithAuth()),
    getUserLanguageMetadata: () => makeGetRequest('metadata', configWithoutAuth()),
    changeAppLanguage: (payload) =>
        makePostRequest('user/v2/app/language/id', JSON.stringify(payload), configWithAuth()),
    createSelfAccessCode: () =>
        makePostRequest('user/v2/access-code', JSON.stringify({}), configWithAuth()),
    setPassword: (payload) =>
        makePostRequest('auth/update-password', JSON.stringify(payload), configWithAuth()),
    acceptTerms: (payload) =>
        makePostRequest('user/v2/terms-acceptance', JSON.stringify(payload), configWithAuth()),
    startSession: () => makeGetRequest('user/v2/session/start', configWithAuth()),
    tickSession: () => makeGetRequest('user/v2/session/tick', configWithAuth()),
    endSession: () => makeGetRequest('user/v2/session/end', configWithAuth()),
}
